// extracted by mini-css-extract-plugin
export var hd = "index-module--hd--1XIGG";
export var sd = "index-module--sd--IAtTI";
export var videoContainer = "index-module--videoContainer--1RcsT";